import React from 'react';

import PropTypes from 'prop-types';

import appSettings from 'wanderu-config';
import { createImageBannerTemplate } from 'wanderu-utils';

import ImageBanner from '../ImageBanner/ImageBanner';

// eslint-disable-next-line css-modules/no-unused-class
import styles from './AboutUsBanners.scss';

const propTypes = {
    label: PropTypes.string.isRequired,
    title: PropTypes.string,
    subtitle: PropTypes.string,
    layoutClassName: PropTypes.string,
};

const defaultProps = {
    title: '',
    subtitle: '',
    layoutClassName: '',
};

function getBucketPath() {
    return `${appSettings.config.s3.staticAssetsUrl}react-ui/media/about-us`;
}

function StatisticsBanner(props) {
    const {
        label,
        title,
        subtitle,
        layoutClassName,
    } = props;

    const imageList = createImageBannerTemplate(
        `${getBucketPath()}/numbers-icon`,
        'about-us-numbers-stat',
        'about-us-numbers-label',
    );

    return (
        <ImageBanner
            className={styles.statBanner}
            imageClassName={styles.statImages}
            imageList={imageList}
            label={label}
            layoutClassName={layoutClassName}
            subtitle={subtitle}
            title={title}
        />
    );
}

StatisticsBanner.propTypes = propTypes;
StatisticsBanner.defaultProps = defaultProps;

export {
    StatisticsBanner,
};
